export const sizes = {
	nav: {
		height: {
			desktop: '90px',
		},
	},
}


// WEBPACK FOOTER //
// ./src/config/general.js